import { t } from '@lingui/core/macro';
import { Alert } from '@pocketlaw/tetris';
export function ErrorAlert(props) {
    const { hasError } = props;
    if (!hasError) {
        return null;
    }
    return (<Alert appearance="danger" message={t({
            message: 'Something went wrong, please try again later',
            comment: 'Error alert message',
        })}/>);
}
